import { Address } from '../../../member-profile/components/Address';

const AddressPage = () => {
    return <Address />;
};

export default AddressPage;
